import { Link, LinkProps } from "@mui/material";

export type ExternalLinkProps = Omit<LinkProps, "href" | "target" | "rel"> & {
  href: string;
};

export function ExternalLink({ href, children, ...props }: ExternalLinkProps) {
  return (
    <Link href={href} target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </Link>
  );
}
